module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Medium.655d6101.eot";